import { render, staticRenderFns } from "./SalarieTaxFreeIndex.vue?vue&type=template&id=b1ac93c2&scoped=true"
import script from "./SalarieTaxFreeIndex.vue?vue&type=script&lang=js"
export * from "./SalarieTaxFreeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ac93c2",
  null
  
)

export default component.exports